<template>
  <v-container>
    <v-data-table
      :no-data-text="('Receipts no DataText')"
      :disable-pagination="true"
      :hide-default-footer="true"
      :items-per-page="100"
      :headers="headers"
      :items="campaigns"
      class="elevation-1"
    >
      <!-- <template v-slot:header.campaign.title="{ header }">
        <v-text-field v-model="searchCampaignTitle" label="Campaign Title"></v-text-field>
      </template>
      <template v-slot:item.campaign.status="{ item }">
        <v-chip :color="getColor(item.campaign.status)" dark>{{ item.campaign.status }}</v-chip>
      </template> -->
      <template v-slot:item.campaign.status="{ item }">
        <v-chip :color="getColor(item.campaign.status)" dark>{{ item.campaign.status }}</v-chip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
const APIUrl = process.env.VUE_APP_API_URL;
export default {
  data() {
    return {
      showMenu: false,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" }
      ],
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "campaign.id"
        },
        { text: "Title", value: "campaign.title" },
        { text: "Client", value: "client.name" },
        { text: "Start", value: "campaign.start" },
        { text: "End", value: "campaign.end" },
        { text: "Status", value: "campaign.status" },
        { text: "Type", value: "campaign.type" },
        { text: "Max.", value: "campaign.maxParticipants" },
        { text: "Entry P/P", value: "campaign.entryPerPerson" }
      ],
      campaigns: [],
      searchCampaignTitle:""
    };
  },
  watch: {
    searchCampaignTitle(val) {
      // const found = this.campaigns.filter(c=>c.campaign.title.includes(val))
      // console.log(found)
      // this.campaigns = found
    }
  },
  mounted() {
    this.searchCampaign({
      sessid: this.userToken
    }).then(res => {
      this.campaigns = res.campaigns;
    });
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  methods: {
    ...mapActions(["searchCampaign"]),
    getColor(status) {
      if (status === "Finished") return "red";
      else if (status === "New") return "amber";
      else if (status === "Paused") return "grey";
      else if (status === "Active") return "green";
      else return "blue-grey";
    }
  }
};
</script>
